import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS, getHeaders } from '../config/api.config';
import { Employee, PaginatedResponse } from '../../types';

class EmployeeService {
    async listEmployees(token: string, params: { page: number; per_page: number; search?: string; sort?: string; order?: 'asc' | 'desc' }, companyId: number): Promise<PaginatedResponse<Employee>> {
        try {
            const response = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.EMPLOYEE.LIST}`, {
                params,
                headers: getHeaders(token, companyId)
            });
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    async getEmployee(id: number, token: string, companyId: number): Promise<Employee> {
        try {
            const response = await axios.get(`${API_BASE_URL}${API_ENDPOINTS.EMPLOYEE.GET}/${id}`, {
                headers: getHeaders(token, companyId)
            });
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    async createEmployee(data: Partial<Employee>, token: string, companyId: number): Promise<Employee> {
        try {
            const response = await axios.post(`${API_BASE_URL}${API_ENDPOINTS.EMPLOYEE.CREATE}`, data, {
                headers: getHeaders(token, companyId)
            });
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    async updateEmployee(id: number, data: Partial<Employee>, token: string, companyId: number): Promise<Employee> {
        try {
            const response = await axios.put(`${API_BASE_URL}${API_ENDPOINTS.EMPLOYEE.UPDATE}/${id}`, data, {
                headers: getHeaders(token, companyId)
            });
            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    async deleteEmployee(id: number, token: string, companyId: number): Promise<void> {
        try {
            await axios.delete(`${API_BASE_URL}${API_ENDPOINTS.EMPLOYEE.DELETE}/${id}`, {
                headers: getHeaders(token, companyId)
            });
        } catch (error: any) {
            throw error;
        }
    }
}

// Export a singleton instance
export const employeeService = new EmployeeService();
